export const firstLastIndexOfRegex = (str, regex) => {
  let result;
  const indices = [];
  while ((result = regex.exec(str))) {
    indices.push(result.index);
  }
  return [indices[0], indices[indices.length - 1]];
};
